import React, { Component } from "react";
import LoaderStyle from "./LoaderStyle";
import isEmpty from "../../validation/is-empty";

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowLoader: false,
    };
  }

  componentDidUpdate(previousProp) {
    if (previousProp !== this.props) {
      this.setState({ isShowLoader: this.props.isShowLoader });
    }
  }

  render() {
    const { isShowLoader } = this.state;
    return (
      <>
        {isShowLoader && (
          <div>
            {LoaderStyle}
            <div id="pageloader-overlay" className="visible incoming">
              <div className="loader-wrapper-outer">
                <div className="loader-wrapper-inner">
                  {(this.props.loadingText) && !isEmpty(this.props.loadingText) ? <h3 className="mb-4" style={{fontSize:"xx-large", fontWeight:800, color:"rgb(254 71 32)"}}>{this.props.loadingText}</h3> : null}
                  <div className="loader"></div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
export default Loader;
